import { Undefineable } from '../../../models/Undefineable';

export const isTokenValid = (
  nowAsMilliseconds: Undefineable<number>,
  tokenExpirationAsMilliseconds: Undefineable<number>
) =>
  !!tokenExpirationAsMilliseconds &&
  !!nowAsMilliseconds &&
  tokenExpirationAsMilliseconds >= nowAsMilliseconds;
